export default __webpack_public_path__ + "static/media/covid.7a8882c7.svg";